<template>
    <div class="row mt-4">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <h4 v-if="payment.title !== 'GCash'">{{ payment.title }}</h4>
                    <img class="logo" :src="payment.logo" alt="">

                    <form id="paymentForm" v-if="payment.type !== 'aub_installment' & payment.type !== 'security_installment'"
                          action="../process_payment.php" method="post" @submit="submit">
                        <input type="hidden" name="paymentType" :value="payment.type">

                        <!-- INSTALLMENT FORM -->
                        <div v-if="payment.hasOwnProperty('terms')" class="row mt-4">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="ddlPayment" class="col-4 col-form-label">Payment For</label>
                                    <div class="col-8">
                                        <select class="custom-select form-control" name="ddlPayment" id="ddlPayment">
                                            <option v-for="(pmtFor, index) in payment.payments_for" :key="index"
                                                    :value="pmtFor">{{ pmtFor }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="txtreferenceno" class="col-4 col-form-label">Reference #</label>
                                    <div class="col-8">
                                        <input type="text" name="txtreferenceno" id="txtreferenceno"
                                               class="form-control" autocomplete="off" required>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="txtmembername" class="col-4 col-form-label">Member's Name</label>
                                    <div class="col-8">
                                        <input type="text" name="txtmembername" id="txtmembername" class="form-control"
                                               autocomplete="off" required>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="txtcardholdername" class="col-4 col-form-label">CardHolder's
                                        Name</label>
                                    <div class="col-8">
                                        <input type="text" name="txtcardholdername" id="txtcardholdername"
                                               class="form-control" autocomplete="off" required>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="txtemail" class="col-4 col-form-label">Email Address</label>
                                    <div class="col-8">
                                        <input type="email" name="txtemail" id="txtemail" class="form-control"
                                               autocomplete="off" required>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="terms" class="col-4 col-form-label">Tenor</label>
                                    <div class="col-8">
                                        <select class="custom-select form-control" name="terms" id="terms"
                                                v-model="selectedTerm" @change="setMinimum(selectedTerm)" required>
                                            <option v-for="(term, index) in payment.terms" :key="index" :value="term">{{
                                                term }} Months
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="txtamount" class="col-4 col-form-label">Total Amount</label>
                                    <div class="col-8">
                                        <input type="number" step="any" name="txtamount" id="txtamount"
                                               class="form-control" :min="minimum" autocomplete="off" required>
                                        <sub v-if="minimum > 0" class="min-desc">Minimum amount <strong>{{
                                            formattedMinimum }}</strong></sub>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- INSTALLMENT FORM END -->

                        <!-- ONE TIME PAYMENT FORM -->
                        <div v-else class="row mt-4">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="ddlPayment" class="col-4 col-form-label">Payment For</label>
                                    <div class="col-8">
                                        <select class="custom-select form-control" name="ddlPayment" id="ddlPayment">
                                            <option v-for="(pmtFor, index) in payment.payments_for" :key="index"
                                                    :value="pmtFor">{{ pmtFor }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="txtreferenceno" class="col-4 col-form-label">Reference #</label>
                                    <div class="col-8">
                                        <input type="text" name="txtreferenceno" id="txtreferenceno"
                                               class="form-control" autocomplete="off" required>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="txtmembername" class="col-4 col-form-label">Member's Name</label>
                                    <div class="col-8">
                                        <input type="text" name="txtmembername" id="txtmembername" class="form-control"
                                               autocomplete="off" required>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label v-if="payment.type === 'bpi_online_banking'" for="txtcardholdername"
                                           class="col-4 col-form-label">Account Name</label>
                                    <label v-else for="txtcardholdername" class="col-4 col-form-label">CardHolder's
                                        Name</label>
                                    <div class="col-8">
                                        <input type="text" name="txtcardholdername" id="txtcardholdername"
                                               class="form-control" autocomplete="off" required>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="txtemail" class="col-4 col-form-label">Email Address</label>
                                    <div class="col-8">
                                        <input type="email" name="txtemail" id="txtemail" class="form-control"
                                               autocomplete="off" required>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="txtamount" class="col-4 col-form-label">Total Amount</label>
                                    <div class="col-8">
                                        <input type="number" step="any" name="txtamount" id="txtamount"
                                               class="form-control" autocomplete="off" required>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- ONE TIME PAYMENT FORM END-->
                        <div class="row mt-4">
                            <div class="col text-center">
                                <button type="submit" class="btn btn-lg btn-primary" :disabled="loading">Pay Now <span
                                        v-if="loading" class="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span></button>
                            </div>
                        </div>

                    </form>

                    <!-- PAYMONGO-->
                    <form  v-else id="payment">
                      <input type="hidden" id="paymentType" name="paymentType" :value="payment.type">
                          <div class="row mt-4 mb-4">
                            <input class="col-4 col-form-label" type="hidden" name="form" value="payment">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label class="col-4 col-form-label custom-label" for="ddlPayment">Payment For</label>
                                    <div class="col-8">
                                        <select class="custom-select form-control" name="ddlPayment" id="ddlPayment">
                                            <option v-for="(pmtFor, index) in payment.payments_for" :key="index"
                                                    :value="pmtFor">{{ pmtFor }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-4 col-form-label custom-label">Reference #</label>
                                    <div class="col-8">
                                        <input class="form-control" type="text" name="ref_no" autocomplete="off"
                                               required>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-4 col-form-label custom-label">Member's Name</label>
                                    <div class="col-8">
                                        <input type="text" name="txtmembername" id="txtmembername" class="form-control"
                                               autocomplete="off" required>
                                    </div>
                                </div>
<!--                                <div class="form-group">-->
<!--                                    <label class="custom-label">Member's Name</label>-->
<!--                                    <input class="form-control" type="text" name="name" required>-->
<!--                                </div>-->
                                <div class="form-group row">
                                    <label class="col-4 col-form-label custom-label">CardHolder's Name</label>
                                    <div class="col-8">
                                        <input class="form-control" type="text" name="name" autocomplete="off" required>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label class="col-4 col-form-label custom-label">Email Address</label>
                                    <div class="col-8">
                                        <input class="form-control" type="email" name="email" autocomplete="off"
                                               required>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-4 col-form-label custom-label" for="terms">Tenor</label>
                                    <div class="col-8">
                                        <select class="custom-select form-control" name="terms" id="terms"
                                                v-model="selectedTerm" @change="setMinimum(selectedTerm)" required>
                                            <option v-for="(term, index) in payment.terms" :key="index" :value="term">{{
                                                term }} Months
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-4 col-form-label custom-label">Total Amount</label>
                                    <div class="col-8">
                                        <input class="form-control" type="number" step="any" name="amount" :min="minimum" required
                                               style="max-width: 100%" autocomplete="off">
                                         <sub v-if="minimum > 0" class="min-desc">Minimum amount <strong>{{
                                                formattedMinimum }}</strong></sub>
                                    </div>
                                </div>
                                <div class="form-group row" hidden>
                                    <label class="col-4 col-form-label custom-label">Payment Method</label>
                                    <div class="col-8">
                                        <select class="form-control" name="mop" id="mop">
                                            <option value="CreditCard">Credit Card</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                          </div>
                        <div class="row mt-4">
                            <div class="col text-center">
                                <button type="submit" id="paymentSubmit" class="btn btn-lg btn-primary" onclick="paymentIntent()">
                                    Pay Now
                                    <div id="paymentLoader" class="spinner-border" role="status"
                                         style="display: none;"></div>
                                </button>
                            </div>
                        </div>
                    </form>

                    <!-- CC Modal -->
                    <!-- Modal -->
                    <div class="modal fade" id="ccModal" role="dialog"  tabindex="-1" aria-labelledby="ccModalLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <!-- Modal content-->
                            <div class="modal-content">
                                <form id="ccForm">
                                    <div class="modal-header custom-label">
                                        <h5 class="modal-title" id="ccModalLabel">Please Enter Credit Card Details</h5>
                                    </div>

                                    <div class="modal-body">

                                        <input type="hidden" name="form" value="cc">
                                        <input type="hidden" id="paymentIntentId">
                                        <input type="hidden" id="paymentIntentClientKey">
                                        <input type="hidden" id="paymentAmount">
                                        <div class="form-group">
                                            <label for="ccNo" class="custom-label">Credit Card No.</label>
                                            <input type="text" id="ccNo" name="ccNo" autocomplete="off">
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-3">
                                                <input type="text" id="ccMonth" name="ccMonth" placeholder="MM"
                                                       autocomplete="off">
                                            </div>
                                            <div class="form-group col-3">
                                                <input type="text" id="ccYear" name="ccYear" placeholder="YYYY"
                                                       autocomplete="off">
                                            </div>
                                            <div class="form-group col-2">
                                                <input type="password" id="ccCvc" name="ccCvc" placeholder="CVC"
                                                       autocomplete="off">
                                            </div>
                                        </div>

                                        <div class="">
                                            <label class="custom-label">Processing Fee:
                                              <span id="processing_fee"></span>
                                            </label>
                                            <br>
                                            <label class="custom-label">Interest Rate:
                                              <span id="interest_rate"></span>
                                            </label>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" id="ccCancel" class="btn btn-primary custom-btn-cancel" onclick="refreshPage()">Cancel</button>
                                        <button type="submit" id="ccSubmit" class="btn btn-primary" onclick="paymentCreate()">Pay</button>
                                    </div>

                                </form>
                            </div>

                        </div>
                    </div>

                    <!-- MESSAGE MODAL -->
                    <div class="modal fade" id="messageModal" tabindex="-1" aria-labelledby="messageModalLabel"
                         aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body">
                                    <h3 id="modal-message"></h3>
                                    <span id="error-msg"></span>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal" onclick="refreshPage()">Ok</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 3DS Modal -->
                    <div class="modal fade" id="threedsModal" tabindex="-1" aria-labelledby="messageModalLabel"
                         aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content" style="width: 500px; height: 500px;">
                                <div class="modal-body" style="padding: 0!important; margin-top: -10px!important;" >
                                    <h3 id="threeds-message"></h3>
                                    <div id="threeds-body"></div>
                                </div>
                                <!--<div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
                                </div>-->
                            </div>
                        </div>
                    </div>

                    <!-- END PAYMONGO-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PaymentForm",
        props: {
            payment: Object
        },
        data() {
            return {
                loading: false,
                minimum: 0,
                selectedTerm: null,
                ref_no: null
            }
        },
        computed: {
            formattedMinimum() {
                return this.minimum.toLocaleString('en-PH', {style: 'currency', currency: 'PHP'})
            }
        },
        mounted() {
            this.setMinimum(this.selectedTerm)
        },
        methods: {
            submit() {
                this.loading = true
            },
            setMinimum(term) {
                if (term >= 3 && term <= 6) {
                    this.minimum = 5000
                } else if (term === 12) {
                    this.minimum = 70000
                } else {
                    this.minimum = 0
                }
            },
            // refreshPage() {
            //     location.reload();
            // }
        }
    }


</script>

<style scoped lang="scss">
    #paymentForm .form-group label {
        color: #00979d;
        font-size: 1.1rem;
    }

    .card {
        background-color: #eff0f1;
        border-radius: 20px;
        min-width: 420px;
    }

    .card-body .logo {
        max-height: 80px;
    }

    .btn-primary {
        background-color: #00979d;
        color: white;
    }

    .min-desc {
        color: red;
    }

    @media only screen and (max-width: 425px) {
        .card-body .logo {
            max-height: 50px;
        }
    }

    .custom-label {
       color: #00979d;
       font-size: 1.1rem;
    }

    .custom-btn-cancel {
        left: 10px;
        position: absolute;
    }
</style>

